import React from 'react';

const TechnomindsSection = ({ technomindsData }) => {
    return (
        <section className="technominds-section">
            <div className="container">
                <div className="inner-content">
                    <div className="content-wrapper">
                        <div className="top-row">
                            <div className="left-wrapper">
                                <div className="img-box">
                                    <img src={technomindsData.image} alt="Technominds" />
                                </div>
                            </div>
                            <div className="right-wrapper">
                                <div className="text-wrap">
                                    <h2>{technomindsData.heading}</h2>
                                    <p>{technomindsData.description}</p>
                                    <ul>
                                        {technomindsData.topPoints.map((point, index) => (
                                            <li key={index}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="bottom-wrapper">
                            <ul>
                                {technomindsData.bottomPoints.map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                            <p>{technomindsData.contactText}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TechnomindsSection;
